import * as React from 'react';
export const metaSvg = React.forwardRef(function metaSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F1F5F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M21.225 8c-1.968 0-3.507 1.58-4.9 3.587C14.413 8.99 12.813 8 10.897 8 6.992 8 4 13.417 4 19.15 4 22.737 5.628 25 8.356 25c1.963 0 3.374-.986 5.884-5.663l1.766-3.326c.252.434.518.902.797 1.404l1.177 2.11C20.272 23.615 21.55 25 23.864 25 26.521 25 28 22.706 28 19.044 28 13.041 24.94 8 21.225 8Zm-8.899 10.071c-2.035 3.4-2.738 4.162-3.871 4.162-1.166 0-1.86-1.09-1.86-3.036 0-4.162 1.948-8.418 4.268-8.418 1.257 0 2.308.773 3.916 3.228a342.188 342.188 0 0 0-2.453 4.064Zm7.68-.428-1.407-2.502c-.38-.66-.747-1.267-1.098-1.822 1.268-2.087 2.314-3.127 3.559-3.127 2.584 0 4.652 4.057 4.652 9.04 0 1.899-.583 3.001-1.793 3.001-1.159 0-1.712-.816-3.913-4.59Z',
      fill: '#0366E1',
    }),
  );
});
metaSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var meta = {
  category: 'brand',
  colorable: false,
  name: 'meta',
  svg: metaSvg,
};
